// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oTYl","col":"styles_col__nlvfR"};